"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
ProductsListTypeDirective.$inject = ['storage'];
function ProductsListTypeDirective(storage) {
    return {
        scope: {
            listType: '='
        },
        template: require('./views/products-list-type.html'),
        link: function (scope, element, attrs, ngModel) {
            var preview = storage.getItem('shop_preview');
            if (preview != null) {
                scope.listType = preview;
            }
            else {
                scope.listType = 'table';
            }
            scope.setType = function (type) {
                scope.listType = type;
                storage.setItem('shop_preview', type);
                document.querySelector(".products-list").scrollTop = 0;
            };
        }
    };
}
exports.ProductsListTypeDirective = ProductsListTypeDirective;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/shop/directives/ProductsListTypeDirective.js
// module id = 367
// module chunks = 0